import { useState, useEffect } from "react";
import { FaCheck, FaEdit } from "react-icons/fa";
import Button from "react-bootstrap/Button";

const EditableText = (props) => {
  const { id, value, minLength, maxLength, onValueChanged, readOnly, ...rest } = props;
  const [displayValue, setDisplayValue] = useState(value);
  const [isEditing, setEditing] = useState(false);
  const handleChange = (event) => {
    const newDisplayValue = event.target.value;
    if (newDisplayValue.length <= value.length || newDisplayValue.length <= maxLength) {
      setDisplayValue(newDisplayValue);
    }
  };
  const revertDisplayValue = () => {
    setDisplayValue(value);
  };
  const changeValue = async () => {
    if (displayValue !== value) {
      const newValue = displayValue.trim();
      if (newValue.length >= minLength) {
        await onValueChanged(newValue);
      }
      else {
        revertDisplayValue();
      }
    }
  };
  const handleKeyDown = async (event) => {
    const key = event.key;
    const target = event.target;
    if (key === "Enter") {
      event.preventDefault();
      setEditing(false);
      changeValue();
    } else if (key === "Escape") {
      event.preventDefault();
      setEditing(false);
      revertDisplayValue();
      target.setSelectionRange(target.value.length, target.value.length);
    }
  };
  const handleBlurred = async (event) => {
    setEditing(false);
    changeValue();
  };
  const handleButtonClick = async () => {
    if (isEditing) {
      setEditing(false);
    } else {
      setEditing(true);
      document.getElementById(id).focus();
      document.getElementById(id).select();
    }
  };
  useEffect(() => {
    setDisplayValue(value);
  }, [value]);
  return (
    <>
      <input
        id={id}
        type="text"
        value={displayValue || ""}
        style={{ width: (displayValue?.length + 2 || 10) + "ch" }}
        readOnly={!isEditing}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        onBlur={handleBlurred}
        {...rest}
      />
      <Button
        variant="Light"
        title={isEditing ? "Save" : "Edit"}
        disabled={!isEditing && readOnly}
        onClick={handleButtonClick}
      >
        {isEditing ? <FaCheck /> : <FaEdit />}
      </Button>
    </>
  );
};

export default EditableText;
